import gql from 'graphql-tag'
import Constants from "../../Constants/Constants";

export function generate_UPDATE_RECORD(table) {
    return gql`
 mutation update_${table}($id: uuid!, $obj: ${table}_set_input) {
 update_${table} (
    where: {id: {_eq: $id}}
    _set: $obj
  ) {
    returning {
      id
     }
    }

  }
`
}

export function generate_UPDATE_RECORDS_BY_CONDITION(table) {
    return gql`
 mutation update_${table}($condition: ${table}_bool_exp!, $obj: ${table}_set_input) {
 update_${table} (where: $condition, _set: $obj) {
    returning { id }
    }
  }
`
}

export function generate_CHECK_DUPLICATION(table) {
    return gql`
  query check_duplication_${table}($condition: ${table}_bool_exp!){
  ${table}(where: $condition){
    id
  }
}`
}

export const UPDATE_ORDER_ITEMS = gql`
mutation ($orderItem:[OrderItems_insert_input!]!, $creditDebit:[CreditDebit_insert_input!]!, $updateColumnsCreditDebit: [CreditDebit_update_column!]!,
            $orderItem_on_conflict_rule: OrderItems_on_conflict!, $deleteOrderItemIds: [uuid!], $skipCreditDebit: Boolean!) {
  insert_OrderItems(objects: $orderItem, on_conflict: $orderItem_on_conflict_rule){
   affected_rows
  }
  insert_CreditDebit(objects: $creditDebit, on_conflict: {constraint: CreditDebit_pkey, update_columns: $updateColumnsCreditDebit}) @skip(if: $skipCreditDebit) {
   affected_rows
  }
  delete_OrderItems(where: {id: {_in: $deleteOrderItemIds}}){
   affected_rows
  }
}`

export const UPDATE_ORDER_WITH_ORDER_ITEMS = gql`
mutation ($id: uuid!, $order:Orders_set_input, $orderItem:[OrderItems_insert_input!]!, $creditDebit:[CreditDebit_insert_input!]!, $updateColumnsCreditDebit: [CreditDebit_update_column!]!,
            $orderItem_on_conflict_rule: OrderItems_on_conflict!, $deleteOrderItemIds: [uuid!]) {
  update_Orders(where: {id: {_eq: $id}}, _set: $order){
   affected_rows
  }
  insert_OrderItems(objects: $orderItem, on_conflict: $orderItem_on_conflict_rule){
   affected_rows
  }
  insert_CreditDebit(objects: $creditDebit, on_conflict: {constraint: CreditDebit_pkey, update_columns: $updateColumnsCreditDebit}){
   affected_rows
  }
  delete_OrderItems(where: {id: {_in: $deleteOrderItemIds}}){
   affected_rows
  }
}`
export const UPDATE_ORDER_AND_INSERT_CREDIT = gql`
mutation ($id: uuid!, $order:Orders_set_input, $creditDebit:[CreditDebit_insert_input!]!) {
  update_Orders(where: {id: {_eq: $id}}, _set: $order){
   affected_rows
  }
  insert_CreditDebit(objects: $creditDebit){
   affected_rows
  }
}`

export const ADD_ORDER = gql`
mutation addNewOrder($order:[Orders_insert_input!]!, $orderItems:[OrderItems_insert_input!]!, $creditDebit:[CreditDebit_insert_input!]!,
                     $customer:[Customers_insert_input!]!, $updateColumnsCustomer: [Customers_update_column!]!,
                     $customerCredit:[CustomerCredit_insert_input!]!, $skipCreditDebit: Boolean!) {
  insert_Orders(objects: $order){
   affected_rows
  }
  insert_OrderItems(objects: $orderItems){
   affected_rows
  }
  insert_CreditDebit(objects: $creditDebit)@skip(if: $skipCreditDebit){
   affected_rows
  }
  insert_Customers(objects: $customer, on_conflict: {constraint: Customers_pkey, update_columns: $updateColumnsCustomer}){
    returning{id}
  }
  insert_CustomerCredit(objects: $customerCredit, on_conflict: {constraint: CustomerCredit_pkey, update_columns: []}){
    returning{id}
  }    
}`

export const UPDATE_ORDER_AND_ORDER_ITEMS_BRANCH = gql`
mutation updateOrderAndOrderItemsBranch($orderId: uuid!, $orderObj: Orders_set_input, $orderItemObj: OrderItems_set_input) {
  update_Orders(where: {id: {_eq: $orderId}}, _set: $orderObj){
   affected_rows
  }
  update_OrderItems(where: {orderId: {_eq: $orderId}}, _set: $orderItemObj){
   affected_rows
  }
}`

export const CREATE_UPDATE_ORDER_NOTE = gql`
mutation addOrderNote($note:[Notes_insert_input!]!, $updateColumns: [Notes_update_column!]!) {
  insert_Notes(objects: $note, on_conflict: {constraint: Notes_pkey, update_columns: $updateColumns}){
    returning{id}
  }
}`

export const CREATE_UPDATE_MINIMUM_ORDER = gql`
mutation upsertMinimumOrder($minimumOrder:[MinimumOrder_insert_input!]!, $updateColumns: [MinimumOrder_update_column!]!) {
  insert_MinimumOrder(objects: $minimumOrder, on_conflict: {constraint: MinimumOrder_city_key, update_columns: $updateColumns}){
    returning{id}
  }
}`
export const CREATE_UPDATE_ADDITIONAL_PRICE = gql`
mutation upsertAdditionalPrice($additionalPrice:[AdditionalPrice_insert_input!]!, $updateColumns: [AdditionalPrice_update_column!]!) {
  insert_AdditionalPrice(objects: $additionalPrice, on_conflict: {constraint: AdditionalPrice_typeId_key, update_columns: $updateColumns}){
    returning{id}
  }
}`

export const DELETE_ORDERS = gql`
mutation deleteOrders($startDate:timestamptz!, $endDate:timestamptz!){
  delete_OrderItems(where:{_and: [{Order:{ created_at: {_gte: $startDate}}},{Order:{ created_at: {_lte: $endDate}}}, {Customer:{city:{_ilike: "%surat%"}}}, {Order:{needToKeep: {_eq: false}}},
            {Order:{statusId: {_in: ["${Constants.OrderStatuses.Delivered}","${Constants.OrderStatuses.Canceled}"]}}} ]}){
    returning{id}
  }
  delete_Orders(where:{_and: [{ created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, {Customer:{city:{_ilike: "%surat%"}}}, {needToKeep: {_eq: false}},
            {statusId: {_in: ["${Constants.OrderStatuses.Delivered}","${Constants.OrderStatuses.Canceled}"]}} ]}){
    returning{id}
  }  
}`